import { useState, useCallback } from 'react';
import { eventService } from '../services/eventService';
import { EventData } from '../types/event';

interface UseEventDetailReturn {
  event: EventData | null;
  isLoading: boolean;
  error: string | null;
  fetch: (id: number) => Promise<void>;
  clear: () => void;
}

export const useEventDetail = (): UseEventDetailReturn => {
  const [event, setEvent] = useState<EventData | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async (id: number) => {
    setIsLoading(true);
    setError(null);
    try {
      const data = await eventService.getEventById(id);
      setEvent(data);
    } catch {
      setError('イベント詳細の取得に失敗しました');
    } finally {
      setIsLoading(false);
    }
  }, []);

  const clear = useCallback(() => {
    setEvent(null);
    setError(null);
  }, []);

  return { event, isLoading, error, fetch, clear };
};
